import { css } from '@adornis/chemistry/directives/css.js';
import { html } from 'lit';

export type CtaPillButtonProps = {
  label: string;
  onClick?: (e: Event) => void;
  href?: string;
  class?: string;
  disabled?: boolean;
};

// A pill-shaped CTA button with a primary outline and warning badge arrow, matching the provided design
export const CtaPillButton = (props: CtaPillButtonProps) => {
  const baseInner = (content: unknown) => html`
    <div
      class="rounded-full bg-[#42d2d3] text-[#19182d] hover:bg-[#90dddc] font-bold tracking-tight uppercase min-h-0 h-12 px-6 pr-2 disabled:opacity-60 disabled:cursor-not-allowed flex flex-row items-center w-full sm:w-auto cursor-pointer transition-all duration-300 ease-in-out"
      ?disabled=${props.disabled}
      ${css({ border: 'none', boxShadow: 'none' })}
    >
      <span class="truncate flex-1">${props.label}</span>
      <span class="ml-4 grid place-items-center rounded-full bg-[#e8ef56] text-[#19182d] w-9 h-9 shrink-0">
        <span class="icon-[material-symbols--keyboard-double-arrow-right]" ${css({ fontSize: '24px' })}></span>
      </span>
    </div>
  `;

  if (props.href) {
    return html`
      <a href=${props.href} @click=${props.onClick} class="inline-block w-full sm:w-auto" aria-label=${props.label}>
        ${baseInner(props.label)}
      </a>
    `;
  }

  return html`
    <button
      class="inline-block w-full sm:w-auto"
      ?disabled=${props.disabled}
      @click=${props.onClick}
      aria-label=${props.label}
    >
      ${baseInner(props.label)}
    </button>
  `;
};
